// The under-booked class Helios is filling, plus the smart segment it targets
// and the members who book after the text. One reveal timeline drives the right
// panel feed while the seat grid + rollup stats climb in lockstep.

export const CLASS_INFO = {
  day: "Saturday",
  time: "9:00 AM",
  name: "Sculpt",
  location: "River North",
  coach: "Coach Mia",
  capacity: 20,
  startBooked: 6,
} as const;

export const SEGMENT = {
  name: "Regulars who haven't booked",
  count: 86,
  chips: ["Visited >4× in 30d", "No booking this week"],
} as const;

const CUSTOMERS = "/images/website/customers";

export type FeedItem =
  | { kind: "message"; id: string; body: string; delay: number }
  | { kind: "system"; id: string; text: string; booked?: number; delay: number }
  | {
      kind: "booking";
      id: string;
      name: string;
      src?: string;
      note?: string;
      booked: number;
      waitlist?: boolean;
      delay: number;
    };

// Revealed one at a time. `booked` on a booking item is the class's running
// booked count once that item lands, so the seat grid fills as the feed streams.
export const FEED: FeedItem[] = [
  {
    kind: "message",
    id: "blast",
    body: "Hey {first}, a spot just opened in Saturday 9am Sculpt with Mia. Want me to grab it for you? Reply YES.",
    delay: 1700,
  },
  { kind: "system", id: "sent", text: "Sent to 86 regulars", delay: 1300 },
  {
    kind: "booking",
    id: "maya",
    name: "Maya Rivera",
    src: `${CUSTOMERS}/maya-rivera.jpg`,
    booked: 7,
    delay: 1500,
  },
  {
    kind: "booking",
    id: "devin",
    name: "Devin Carter",
    src: `${CUSTOMERS}/devin-carter.jpg`,
    booked: 8,
    delay: 1300,
  },
  {
    kind: "booking",
    id: "priya",
    name: "Priya Nair",
    src: `${CUSTOMERS}/priya-nair.jpg`,
    booked: 9,
    delay: 1300,
  },
  {
    kind: "booking",
    id: "jordan",
    name: "Jordan Blake",
    booked: 10,
    delay: 1300,
  },
  { kind: "system", id: "burst", text: "+9 more booked within the hour", booked: 19, delay: 1400 },
  {
    kind: "booking",
    id: "alex",
    name: "Alex Mercer",
    note: "Booked the last spot",
    booked: 20,
    delay: 1400,
  },
  { kind: "system", id: "full", text: "Class full · waitlist opened", booked: 20, delay: 1300 },
  {
    kind: "booking",
    id: "casey",
    name: "Casey Lin",
    src: `${CUSTOMERS}/casey-lin.jpg`,
    booked: 20,
    waitlist: true,
    delay: 1500,
  },
  {
    kind: "system",
    id: "auto-promote",
    text: "Send message when assigned to roster from waitlist",
    booked: 20,
    delay: 1400,
  },
];
